import type {
	FetchLinkedSpacesAction,
	FetchLinkedSpacesSuccessAction,
	FetchLinkedSpacesFailureAction,
} from 'state/actions/linked-spaces';
import {
	FETCH_LINKED_SPACES,
	FETCH_LINKED_SPACES_SUCCESS,
	FETCH_LINKED_SPACES_FAILURE,
} from 'state/actions/linked-spaces';
import type { PersistedError } from 'state/persisted/types';

export interface LinkedSpacesState {
	linkedSpaces: string[];
	error?: PersistedError;
}

const defaultState: LinkedSpacesState = {
	linkedSpaces: [],
};

export type HandledActions =
	| FetchLinkedSpacesAction
	| FetchLinkedSpacesSuccessAction
	| FetchLinkedSpacesFailureAction;

export default function reducer(
	state: LinkedSpacesState = defaultState,
	action: HandledActions,
): LinkedSpacesState {
	switch (action.type) {
		case FETCH_LINKED_SPACES: {
			return {
				...state,
				error: undefined,
			};
		}

		case FETCH_LINKED_SPACES_SUCCESS: {
			const { linkedSpaces } = action.payload;
			return {
				...state,
				linkedSpaces: linkedSpaces || [],
				error: undefined,
			};
		}

		case FETCH_LINKED_SPACES_FAILURE: {
			const { error } = action.payload;
			return {
				...state,
				error: {
					error: {
						status: error.status,
						message: error.message || 'Failed to fetch linked spaces',
						callToActionText: '',
						callToActionUrl: '',
					},
				},
			};
		}

		default:
			return state;
	}
}
